import { useUserStore } from '~/stores/user';
import { getAuth, signOut } from 'firebase/auth';
import { useFirebaseApp } from 'vuefire';

export default defineNuxtPlugin((nuxtApp) => {
  const auth = getAuth(useFirebaseApp());

  nuxtApp.provide('currentUser', () => {
    const userStore = useUserStore();

    if (userStore.user) {
      return {
        ...userStore.user,
        async logout() {
          try {
            await signOut(auth);
            userStore.clearUser();
            console.log('User logged out successfully');
          } catch (error) {
            console.error('Error during logout:', error);
          }
        },
        async getToken(forceRefresh = false) {
          try {
            const token = await auth.currentUser?.getIdToken(forceRefresh);
            return token;
          } catch (error) {
            console.error('Error retrieving token:', error);
            throw error;
          }
        },
      };
    }

    return null;
  });
});